import template from './company-logo.html';
import './company-logo.global.css';

export const CompanyLogoComponent = {
  bindings: {
    entity: '<',
  },
  template,
};
